import { clearCompleted } from "../actions";

const deleteCompleted = (cm) => {
    return async (dispatch) => {
        cm.forEach(async (todo) => {
            await fetch(`https://haider-todo.herokuapp.com/todos/${todo.id}`, {
                method: "DELETE",
            });
        });
        dispatch(clearCompleted());
    };
};

export default deleteCompleted;
